import { trim, split, reverse, isNil } from 'lodash/fp';
import { stripQuotes } from 'app/lib/utils/stringUtils';

export const JsonNodeTypes = {
    ARRAY: 'ARRAY',
    STRING: 'STRING',
    BOOLEAN: 'BOOLEAN',
    INTEGER: 'INTEGER',
    DOUBLE: 'DOUBLE',
    OBJECT: 'OBJECT'
};

const getPreviousSiblingsCount = (selectedNode) => {
    let node = selectedNode.prevSibling;
    let count = 0;
    while (node && node.type.name !== '[') {
        count++;
        node = node.prevSibling;
    }
    return count;
};

const needsQuotes = (identifier) => !/^("|)[_A-Za-z][_A-Za-z\d$]*\1$/.test(identifier);
const getValue = (node, property) => {
    if (node.type.name === 'Property') {
        const slice = trim(property.slice(node.from, node.to));
        const value = split(':', slice)[0];
        return needsQuotes(value) ? value : stripQuotes(value);
    }
    return null;
};

const isParentRootElement = (node) =>
    node?.type?.name !== 'Array' && node?.parent?.type?.name === 'JsonText';

const isNodeArrayElement = (node) => {
    const parentNode = node.parent;
    if (isParentRootElement(parentNode)) {
        return false;
    }
    return node.prevSibling && parentNode.type.name === 'Array';
};

const joinPathItems = (items) => {
    let result = items[0];
    items.forEach((item, index) => {
        if (index > 0) {
            result = item.startsWith('[') ? `${result}${item}` : `${result}.${item}`;
        }
    });
    return result;
};
export const getPath = (selectedNode, value) => {
    let node = selectedNode;
    const pathArray = [];

    let arrayIndex = null;
    do {
        const nodeValue = getValue(node, value);
        if (!isNil(arrayIndex)) {
            const pathItem = nodeValue ? `${nodeValue}[${arrayIndex}]` : `[${arrayIndex}]`;
            pathArray.push(pathItem);
            arrayIndex = null;
        } else if (nodeValue) {
            pathArray.push(nodeValue);
        }
        if (isNodeArrayElement(node)) {
            arrayIndex = getPreviousSiblingsCount(node);
        }
        node = node.parent;
    } while (node);

    return joinPathItems(reverse(pathArray));
};

export const getType = (node, text) => {
    const type = node.type.name;
    switch (type) {
        case 'String':
            return JsonNodeTypes.STRING;
        case 'Number': {
            const value = Number(text.slice(node.from, node.to));
            if (Number.isInteger(value)) {
                return JsonNodeTypes.INTEGER;
            }
            return JsonNodeTypes.DOUBLE;
        }
        case 'True':
        case 'False':
            return JsonNodeTypes.BOOLEAN;
        case '}':
        case '{':
        case 'Object':
            return JsonNodeTypes.OBJECT;
        case ']':
        case '[':
        case 'Array':
            return JsonNodeTypes.ARRAY;
        default:
            return null;
    }
};
